import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconTextNew = createSVG({
    width: 48,
    children: (jsx("path", { d: "M28.937 17.999h2.691l2.246-7.919L36.136 18h2.691l3.36-11.998H39.7l-2.297 8.896L34.884 6h-2.022l-2.502 8.896L28.063 6h-2.485zm-9.226-4.953v2.69h5.057V18h-7.422V6.001h7.336v2.263h-4.97v2.553h4.541v2.229zm-6.956.274V6h2.365v11.998h-1.8l-5.14-7.335V18H5.813V6.001h1.8z" })),
});

export { IconTextNew };
